/** @jsx jsx */
import { jsx } from 'theme-ui';
import React from 'react';
import {
  RiLinkedinFill,
  RiInstagramFill,
  RiFacebookFill
} from "react-icons/ri"
import Icons from "../util/socialmedia.json";

const SocialMedia = () => {
  const sIcons = Icons.socialIcons.map((icons, i) => {
    return (
      <div key={i}>
        {icons.icon === "linkedin" ? (
          <a href={icons.url} target="_blank" rel="noopener noreferrer">
            <RiLinkedinFill/>
          </a>
        ) : (
          ""
          )}

        {icons.icon === "instagram" ? (
          <a href={icons.url} target="_blank" rel="noopener noreferrer">
            <RiInstagramFill/>
          </a>
        ) : (
          ""
          )}     
          {icons.icon === "facebook" ? (
            <a href={icons.url} target="_blank" rel="noopener noreferrer">
              <RiFacebookFill/>
            </a>
          ) : (
            ""
          )}     
      </div>
    )
  })

  return (
    <>
      <div className="social-icons" sx={indexStyles.socialIcons}>
        {sIcons}
      </div>
    </>
  )
}

export default SocialMedia

const indexStyles = {
  socialIcons: {
    a: {
      color: "socialIcons",
      ":hover": {
        color: "socialIconsHover",
      },
    },
  },
}
